import { format } from "date-fns";

/**
 * Date型から "YYYY-MM-DD" 形式にフォーマットする
 * @param date Dateオブジェクト
 * @returns フォーマット済み日付文字列（例："2025-08-04"）
 */
export const dateFormat2 = (date?: Date | null): string => {
  if (!date) return "";

  try {
    const formatted = format(date, "yyyy-MM-dd");

    // 無効な初期値チェック（必要ならここで調整）
    if (formatted === "0001-01-01") {
      return "";
    }

    return formatted;
  } catch {
    return "";
  }
};
